import computeTagName from "../../../../utils/computeTagName";
import computeClassName from '../../../../utils/computeClassName';
import PartnerNameRoleAndLevelDescription from './NameRoleAndLevelDescription';
import PartnerRoleExpertises from './RoleExpertises';

const constants = Object.freeze({
  CLASSNAME_BASE : 'space-y-16',
  CLASSNAME_SECTION_BASE: 'block sm:flex sm:flex-row sm:space-x-20',
  CLASSNAME_SECTION_IS_NOT_FIRST: {
    true: 'pt-12 sm:pt-16 border-t border-cc-gray-05',
    false: ''
  },
  TAG_DEFAULT: 'div'
});

const propsDefaults = Object.freeze({
  tag: constants.TAG_DEFAULT
});

function getComputedSectionClassName(isNotFirst) {
  return computeClassName(constants.CLASSNAME_SECTION_BASE, `${constants.CLASSNAME_SECTION_IS_NOT_FIRST[isNotFirst]}`);
}

export default function PartnerNameRolesLevelsAndExpertises(
  {
    name,
    rolesAndLevels,
    expertises,
    className = '',
    tag= propsDefaults.tag
}) {
  if (!!name && !!name.length && !!rolesAndLevels && ('object' === typeof rolesAndLevels)) {
    const ComputedComponentTag = computeTagName(tag, constants.TAG_DEFAULT);
    const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
    const roles = Object.keys(rolesAndLevels);
    const levels = Object.values(rolesAndLevels);
    return (
      <ComputedComponentTag className={computedClassName}>
        {
          roles.map((role, index) => {
            const computedSectionClassName = getComputedSectionClassName(index > 0);
            return (
              <section key={index} className={computedSectionClassName}>
                <PartnerNameRoleAndLevelDescription className="sm:w-1/2 mb-12 sm:mb-0" name={name} role={role} level={levels[index]}/>
                <PartnerRoleExpertises className="sm:w-1/2" role={role} expertises={expertises}/>
              </section>
            );
          })
        }
      </ComputedComponentTag>
    )
  }
  else {
    return null;
  }
}
